var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningRedTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53984 7.17433C5.48541 3.72478 6.4582 2 7.9987 2C9.53919 2 10.512 3.72477 12.4576 7.17432L12.7 7.60418C14.3168 10.4707 15.1251 11.904 14.3945 12.952C13.6639 14 11.8563 14 8.24114 14H7.75626C4.14107 14 2.33348 14 1.60287 12.952C0.872259 11.904 1.68064 10.4707 3.2974 7.60418L3.53984 7.17433Z",
    stroke: "#E12D2D",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33398V8.66732",
    stroke: "#E12D2D",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "matrix(1 0 0 -1 7.19922 11.5)",
    fill: "#E12D2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRedTriangle);
export default __webpack_public_path__ + "static/media/WarningRedTriangle.435031d64fd3d5b7e0fe2f2a1452dd57.svg";
export { ForwardRef as ReactComponent };